import { render, staticRenderFns } from "./UserUploadBox.vue?vue&type=template&id=c9a55e84&scoped=true&"
import script from "./UserUploadBox.vue?vue&type=script&lang=js&"
export * from "./UserUploadBox.vue?vue&type=script&lang=js&"
import style0 from "./UserUploadBox.vue?vue&type=style&index=0&id=c9a55e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a55e84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
